import { io } from "socket.io-client";

import { getToken } from "./redux/store-utils";

export const socket = io(process.env.REACT_APP_API_URL.slice(0, -4), {
  autoConnect: false,
  path: "/api/socket.io",
  transports: ["websocket"],
  auth: (cb) => cb({ token: getToken() }),
});
